export default class ViewNumberVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------

	name = "Number";
	defaultValue = 0;
	fieldType = 'number';
	uiComponent = 'view-number-field';
	description = 'Regular number.';

	constructor()
	{
		
	}
}